import { FC, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { SmsTemplate } from './smsTemplateListFlowMapper';

type SmsTemplateCardProps = {
  template: SmsTemplate;
  onSelect?: (template: SmsTemplate) => void;
};

export const SmsTemplateCard: FC<SmsTemplateCardProps> = ({ template, onSelect }) => {
  const { t } = useTranslation('campaign');
  const isClickable = Boolean(onSelect);

  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (!onSelect) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect(template);
    }
  };

  return (
    <article
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={isClickable ? () => onSelect?.(template) : undefined}
      onKeyDown={isClickable ? handleKeyDown : undefined}
      className={twMerge(
        'rounded-2xl border border-secondary-border bg-white p-4 shadow-sm outline-none transition',
        isClickable && 'cursor-pointer hover:border-blue-300 hover:shadow-md focus-visible:ring-2 focus-visible:ring-blue-400'
      )}
    >
      <div className='space-y-1'>
        <h4 className='text-sm font-semibold text-slate-900'>{template.name}</h4>
        <p className='text-[10px] font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('smsWorkspace.templates.previewLabel')}</p>
        <div className='rounded-lg bg-slate-50 px-3 py-2 text-xs leading-5 text-secondary-700'>
          <p className='line-clamp-3'>{template.previewText || template.id}</p>
        </div>
      </div>
    </article>
  );
};
